import { useEffect, useState } from "react";

/**
 * CSS 미디어 쿼리 결과를 구독한다.
 *
 * <p>대부분의 반응형은 Tailwind 클래스로 끝내는 게 맞다. 이 훅은 <strong>보여줄 데이터의 양
 * 자체가 달라져야 할 때</strong>만 쓴다 — 예를 들어 가동률 막대를 데스크톱 90일 / 모바일 30일로
 * 나누는 경우, CSS 로 뒤쪽 슬롯만 숨기면 함께 표시되는 "평균 N일" 라벨이 실제 보이는 막대 수와
 * 어긋난다. 그런 불일치를 막으려면 JS 가 개수를 알아야 한다.</p>
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined" || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return;
    const mql = window.matchMedia(query);
    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    // 쿼리가 바뀌었을 수 있으니 현재 값으로 한 번 맞춘다.
    setMatches(mql.matches);
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}

/** Tailwind `sm` 브레이크포인트(640px) 미만인지 — 모바일 분기의 단일 기준점. */
export function useIsMobile(): boolean {
  return useMediaQuery("(max-width: 639px)");
}
